import "./AddEditContactDrawer.scss";

import { default as AddEditContactDrawer } from "./AddEditContactDrawer";

export default AddEditContactDrawer;